import { render, staticRenderFns } from "./FormaDataForma.vue?vue&type=template&id=5390c388&scoped=true&"
import script from "./FormaDataForma.vue?vue&type=script&lang=js&"
export * from "./FormaDataForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5390c388",
  null
  
)

export default component.exports